import 'react-h5-audio-player/src/styles.scss';
import { ReactComponent as PauseIcon } from '../../assets/audio/pause.svg';
import { ReactComponent as PlayIcon } from '../../assets/audio/play.svg';
import AudioPlayer from 'react-h5-audio-player';
import React from 'react';

type Props = {
    track: any;
    opened: boolean;
};

export default function GameAudioPlayer({ track, opened }: Props) {
    return (
        <React.Fragment>
            {opened && (
                <div className="audio-player-wrapper">
                    <AudioPlayer
                        autoPlay
                        src={track}
                        showJumpControls={false}
                        customVolumeControls={[]}
                        customAdditionalControls={[]}
                        layout="horizontal-reverse"
                        customIcons={{
                            play: <PlayIcon />,
                            pause: <PauseIcon />,
                        }}
                    />
                </div>
            )}
        </React.Fragment>
    );
}
